import { render, staticRenderFns } from "./quickBIViewer.vue?vue&type=template&id=ae011aa8&"
import script from "./quickBIViewer.vue?vue&type=script&lang=js&"
export * from "./quickBIViewer.vue?vue&type=script&lang=js&"
import style0 from "./quickBIViewer.vue?vue&type=style&index=0&id=ae011aa8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports